import React from "react";
import PolicyLayout from "../components/PolicyLayout";

const disclaimerContent = [
  {
    id: "general-information",
    title: "General Information",
    content:
      "The information on the Tanuraaga website is provided for general shopping, product discovery, and customer support purposes. We try to keep all details accurate and updated, but occasional errors or omissions may occur.",
  },
  {
    id: "product-display",
    title: "Product Display",
    content:
      "Product images, saree colors, borders, zari shine, fabric texture, and blouse piece details may vary slightly due to lighting, photography, screen settings, or device display differences.",
  },
  {
    id: "fabric-and-care",
    title: "Fabric And Care",
    content:
      "Fabric descriptions and care guidance are shared to help customers make informed choices. Actual feel, drape, transparency, and softness may vary based on weave, finish, and fabric composition.",
  },
  {
    id: "availability-and-pricing",
    title: "Availability And Pricing",
    content:
      "Product availability, pricing, offers, shipping charges, and delivery timelines may change without prior notice. Tanuraaga reserves the right to correct pricing or product information before confirming an order.",
  },
  {
    id: "external-links",
    title: "External Links",
    content:
      "Our website may contain links to social media platforms or third-party services. Tanuraaga is not responsible for the content, privacy practices, or policies of external websites.",
  },
  {
    id: "liability",
    title: "Limitation Of Liability",
    content:
      "Tanuraaga is not liable for indirect, incidental, or consequential losses arising from website use, order delays caused by courier partners, incorrect customer information, or unavoidable technical issues.",
  },
  {
    id: "updates",
    title: "Policy Updates",
    content:
      "This disclaimer may be updated from time to time to reflect business, website, product, or legal changes. Continued use of the website means you accept the latest version.",
  },
];

const DisclaimerPage = () => (
  <PolicyLayout
    activeLabel="Disclaimer"
    className="disclaimer-page"
    title="Disclaimer"
    intro={{
      title: "Important Note",
      content:
        "Tanuraaga aims to present every saree with honesty and care. This disclaimer explains practical limitations around online product display, website information, and customer expectations.",
    }}
    sections={disclaimerContent}
  />
);

export default DisclaimerPage;
